/**
 * Created by Ning Jiang on 2/7/2018.
 */
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {
    StepCountUpBigWinController
} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline} from "gsap";
import {IceIceYetiSoundConfig} from "../../IceIceYetiSoundConfig";
import {IceIceYetiBigWinView} from "./IceIceYetiBigWinView";
import {IceIceYetiGameModuleConfig} from "../../IceIceYetiGameModuleConfig";

export class IceIceYetiBigWinController extends StepCountUpBigWinController {

    public static _gameView:IceIceYetiBigWinView;
    private _isAborted:boolean;

    constructor(indexes:[number, number]) {
        super(indexes, {});
        IceIceYetiBigWinController._gameView = new IceIceYetiBigWinView();
    }

    protected startWinPresentation(): void {
        this._isAborted = false;
        if (IceIceYetiGameModuleConfig.initialWPController._displayIndividualWinsInGame == true) {
            IceIceYetiGameModuleConfig.initialWPController._initialToggleView.playWinPresentation(() => {
                if (this._isAborted == false){
                    super.startWinPresentation()
                }
            });
        } else {
            super.startWinPresentation();
        }
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return IceIceYetiBigWinController._gameView.playCountUp(from, to, duration);
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        if(level == 0) {
            IceIceYetiBigWinController._gameView.preCalculateCountScale(this._gameData!.totalWin);
        }
        return IceIceYetiBigWinController._gameView.getBigWinLevelAnimation(this._winRatios[level]);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        if(isAborted == true) {
            SlotGame.sound.stopEffect(this.getBigWinSound());
        }
        SlotGame.sound.playEffect(this.getBigWinEndSound());
        IceIceYetiBigWinController._gameView.playEndingAnimation(this._winRatios[this._winLevel], isAborted, this._gameData!.totalWin);
    }

    protected playBigWinSound():void {
        SlotGame.sound.playEffect(this.getBigWinSound());
    }

    protected stopAllSounds():void {
        //
    }

    private getBigWinSound():string {
        switch(this._gameData!.currentWinRatioConfig!.type) {
            case WinRatioType.SUPER_MEGA_WIN :
                return IceIceYetiSoundConfig.instance.BIG_WIN_LEVEL_03;
            case WinRatioType.MEGA_WIN :
                return IceIceYetiSoundConfig.instance.BIG_WIN_LEVEL_02;
            default :
                return IceIceYetiSoundConfig.instance.BIG_WIN_LEVEL_01;
        }
    }

    private getBigWinEndSound(): string {
        switch (this._gameData!.currentWinRatioConfig!.type) {
            case WinRatioType.SUPER_MEGA_WIN :
                return IceIceYetiSoundConfig.instance.BIG_WIN_ENDS_03;
            case WinRatioType.MEGA_WIN :
                return IceIceYetiSoundConfig.instance.BIG_WIN_ENDS_02;
            default :
                return IceIceYetiSoundConfig.instance.BIG_WIN_ENDS_01;
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        this._isAborted = isAborted;
        super.stopWinPresentation(isAborted);
    }
}